import _ from "lodash";

const formatDate = (stringDate, withTime = false) => {
  const date = new Date(stringDate);
  // Format the date object into the desired format (DD/MM/YYYY)

  const dateFormat = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  if (withTime) {
    dateFormat["hour"] = "2-digit";
    dateFormat["minute"] = "2-digit";
  }

  const formattedDate = date.toLocaleDateString("en-GB", dateFormat);
  return formattedDate;
};

const formatContact = (number) => {
  // Convert the number to a string
  let str = number.toString();

  // Ensure the string is 10 digits long
  if (str.length !== 10) {
    str = "6845550102";
  }

  // Format the string
  const formatted = `(${str.slice(0, 3)}) ${str.slice(3, 6)}-${str.slice(6)}`;

  return formatted;
};

function numbersFormatter(str) {
  if (!str || typeof str !== "string") {
    return "N/A";
  }
  // Remove leading/trailing whitespace
  str = str.trim();

  // Check if empty string
  if (str === "") {
    return "N/A";
  }

  // Attempt conversion to number using parseFloat
  const number = parseFloat(str);

  // Check if conversion was successful (not NaN)
  if (isNaN(number)) {
    return "N/A";
  }

  // Return the number with two decimal places
  return number.toFixed(2);
}

function getFixedNumber(str) {
  // Remove leading/trailing whitespace
  let number = str;
  if (typeof str === "string") {
    str = str.trim();
    // Check if empty string
    if (str === "") {
      return 0;
    }
    // Attempt conversion to number using parseFloat
    number = parseFloat(str);
  }

  // Check if no value
  if (!number) {
    return 0;
  }

  // Check if conversion was successful (not NaN)
  if (isNaN(number)) {
    return 0;
  }

  // Return the number with two decimal places
  return number.toFixed(2);
}

function truncateString(str) {
  if (str.length > 25) {
    return str.substring(0, 25) + "...";
  } else {
    return str;
  }
}

function formatCategories(categories) {
  return categories.map((category) => ({
    value: category.id,
    label: category.name,
  }));
}

function formatCategoriesList(categories) {
  return categories.map((category) => ({
    id: category.id,
    name: category.name,
    nameAr: category.name_arabic,
    sessionCount: category.session_count,
    isVisible: category.status === 1,
  }));
}

const isHTML = (str) => {
  // Check if string contains HTML tags
  const htmlTagRegex = /<[^>]+>/;
  return htmlTagRegex.test(str);
};

function formatHTMLResponse(text) {
  if (!text) return text;

  // If it's HTML, wrap it with the chat container class
  if (isHTML(text)) {
    return `<div class="chat-container">${text}</div>`;
  }

  // If it's not HTML, return as is
  return text;
}

const getLanguageCode = (language) => {
  language = _.lowerCase(language);
  const arabicLangs = ["arabic", "ar"];
  const englishLangs = ["english", "en"];
  if (_.includes(arabicLangs, language)) {
    language = "ar-SA";
  } else if (_.includes(englishLangs, language)) {
    language = "en-US";
  }
  return language;
}

export {
  formatDate,
  formatContact,
  numbersFormatter,
  getFixedNumber,
  truncateString,
  formatCategories,
  formatCategoriesList,
  isHTML,
  formatHTMLResponse,
  getLanguageCode,
};
